import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';

import ApiUiController from '../../../controller/ApiUiController';
import KeyValueAPI from '../../../api/KeyValueAPI';
import withRouter from '../../../util/WithRouter';

import './Template.css';
import Util from '../../../util/Util';

class EmailConfig extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inApiCall: true, host: '', port: '', secure: false,
      auth: { user: '', pass: '' }
    };

    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.length - 'mass-email'.length);
    this.key = 'mass-email';
  }

  componentDidMount() { KeyValueAPI.get(this.key, this.onSuccess, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onSuccess = res => {
    const state = res.value ? res.value : {};
    this.setState({ ...this.state, ...state, inApiCall: false });
  };

  onChange = (field, val) => {
    const state = { ...this.state };
    if (field.includes('.')) {
      const fields = field.split('.');
      state[fields[0]][fields[1]] = val;
    } else state[field] = val;
    this.setState({ ...state });
  };

  onSave = () => {
    let state = { ...this.state };
    delete state.inApiCall;
    KeyValueAPI.save(this.key, KeyValueAPI.JSON, state, this.onSaved, this.onFail);
  };

  onSaved = () => this.props.navigate(this.base);

  render() {

    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12">
              <h3 className="pb-3">Promotional Email Configuration</h3>
            </div>
          </div>

          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col">
                <div className="form-group">
                  <label>Host</label>
                  <FormControl type="text" value={this.state.host} className="mr-sm-2"
                    onChange={event => this.onChange('host', event.target.value)} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Port</label>
                  <FormControl type="number" value={this.state.port} className="mr-sm-2"
                    onChange={event => this.onChange('port', event.target.value)} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Secure</label>
                  <div className="inline-formcheck">
                    <Form.Check onChange={() => this.onChange('secure', true)}
                      checked={this.state.secure} /> <label class="marginlab">Yes</label>
                    <Form.Check onChange={() => this.onChange('secure', false)}
                      checked={!this.state.secure} /> <label>No</label>
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Username</label>
                  <FormControl type="text" value={this.state.auth.user} className="mr-sm-2"
                    onChange={event => this.onChange('auth.user', event.target.value)} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Password</label>
                  <FormControl type="password" value={this.state.auth.pass} className="mr-sm-2"
                    onChange={event => this.onChange('auth.pass', event.target.value)} />
                </div>
              </div>

              <div className="col-md-12 text-center btnsend pt-4">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(EmailConfig);